import { colors, fonts } from '../../theme';

// Same card as the choices of the upload form: dark, thin border, rounded.
// 10 % lower than the first version (32px): the line takes less room on the video.
const card = {
  flexShrink: 0,
  height: 29,
  px: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  borderRadius: '8px',
  border: `1px solid ${colors.border}`,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
};

const styles = {
  line: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.375,
    minWidth: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontFamily: fonts.text,
    fontSize: 12.5,
    fontWeight: 600,
    color: colors.text,
  },
  card,
  // Compact line (rows of the ranking): the same cards, smaller.
  cardSmall: {
    ...card,
    height: 24,
    px: 0.875,
    borderRadius: '7px',
    fontSize: 11.5,
  },
  iconCardSmall: {
    ...card,
    width: 28,
    height: 24,
    px: 0,
    borderRadius: '7px',
    fontSize: 14,
    '& svg': {
      fontSize: 14,
    },
  },
  weaponIconSmall: {
    display: 'block',
    width: 17,
    height: 17,
    objectFit: 'contain',
  },
  // Platform, game and weapon: the same square card, the icon centered and of the same size.
  iconCard: {
    ...card,
    width: 32,
    px: 0,
    fontSize: 16,
    '& svg': {
      fontSize: 16,
    },
  },
  // The ∞: an icon card, the sign a bit bigger than the other icons (it is thin).
  infiniteCard: {
    ...card,
    width: 32,
    px: 0,
    '& svg': {
      fontSize: 20,
    },
  },
  infiniteCardSmall: {
    ...card,
    width: 28,
    height: 24,
    px: 0,
    borderRadius: '7px',
    '& svg': {
      fontSize: 17,
    },
  },
  // The mode can be long: it is the one cut when the line is full.
  mode: {
    ...card,
    flexShrink: 1,
    minWidth: 0,
    display: 'inline-block',
    lineHeight: '27px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 500,
    color: colors.textLight,
  },
  // A small thumbnail of the logo, as big as the other icons.
  gameIcon: {
    display: 'block',
    width: 20,
    height: 20,
    objectFit: 'contain',
  },
  // The weapon images are squares filled at 80 to 97 %: about 72 % of the card, so a long weapon
  // doesn't touch the edges (20px in the 27px card of the app).
  weaponIcon: {
    display: 'block',
    width: 21,
    height: 21,
    objectFit: 'contain',
  },
};

export default styles;
